import * as Videos from './videos'

export default {
  Videos,
}
